import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const EpButton = ({
  buttonText, buttonStartIcon, buttonEndIcon, customClass, disabled, actionType, buttonType,
  buttonWidthType, buttonId, dataBsToggle, ariaExpanded, autoClose, onClickFunc, isActive,
  buttonSize, dataBsTarget, ariaControls,
}) => (
  <button
    aria-controls={ariaControls}
    data-bs-target={dataBsTarget}
    onClick={onClickFunc}
    type={actionType}
    className={`btn btn--${buttonType} btn--${buttonWidthType} ${customClass} ${buttonSize && ` btn--${buttonSize} `}${isActive && `btn--${buttonType}-active`}`}
    disabled={disabled}
    id={buttonId}
    data-bs-toggle={dataBsToggle}
    aria-expanded={ariaExpanded}
    data-bs-auto-close={autoClose}
  >
    {buttonStartIcon && <div className="btn__icon btn__icon--start">{buttonStartIcon}</div>}
    {buttonText !== '' && <span className="btn__text">{buttonText}</span>}
    {buttonEndIcon && <div className="btn__icon btn__icon--end">{buttonEndIcon}</div>}
  </button>
);

export default EpButton;

EpButton.defaultProps = {
  buttonText: '',
  buttonType: '',
  buttonWidthType: 'default',
  ariaExpanded: 'false',
  autoClose: 'true',
  dataBsToggle: '',
  customClass: '',
  buttonStartIcon: null,
  buttonEndIcon: null,
  disabled: false,
  buttonId: null,
  onClickFunc: null,
  isActive: false,
  buttonSize: 'md',
  dataBsTarget: '',
  ariaControls: '',
  actionType: 'button',
};

EpButton.propTypes = {
  buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  actionType: PropTypes.oneOf(['submit', 'button', 'reset']),
  buttonType: PropTypes.oneOf(['link', 'link-secondary', 'primary', 'secondary-outline']),
  buttonWidthType: PropTypes.oneOf(['default', 'fullsize']),
  buttonId: PropTypes.string,
  customClass: PropTypes.string,
  buttonStartIcon: PropTypes.element,
  buttonEndIcon: PropTypes.element,
  disabled: PropTypes.bool,
  dataBsToggle: PropTypes.string,
  ariaExpanded: PropTypes.string,
  autoClose: PropTypes.string,
  onClickFunc: PropTypes.func,
  isActive: PropTypes.bool,
  buttonSize: PropTypes.oneOf(['sm', 'md', 'lg']),
  dataBsTarget: PropTypes.string,
  ariaControls: PropTypes.string,
};
